var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('img',{style:(_vm.mStyle),attrs:{"src":_vm.empty_type.img || require('../assets/images/empty.png')}}),_c('p',[_vm._v(_vm._s(_vm.empty_type.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }